<table class="table table-responsive table-hover" *ngIf="programs?.length > 0" style="margin-left: 2rem">
  <thead>
    <tr>
      <th scope="col">Program</th>
      <th scope="col">Program Type</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let program of programs">
      <th scope="row">
        <a routerLink="/program/{{program.id}}/view" target="_blank">{{program.name}}</a>
      </th>
      <td>{{program.programType}}</td>
    </tr>
  </tbody>
</table>
